export default {
  // Phase courante : 'identity' | 'auto' | 'home' | 'success'
  appPhase: "identity",

  // Données du formulaire
  form: {
    civility: "", // 'Mme' | 'Mlle' | 'Mr'
    firstName: "",
    lastName: "",
    phoneDial: "+225",
    phoneNumber: "",
    waDial: "+225",
    waNumber: "",
    sameAsWhatsapp: true,
    hasAuto: null,
    autoExpiryDate: "",
    hasHome: null,
    homeExpiryDate: "",
    eventCode: "default",
  },

  // Activation enregistrée (après succès)
  activation: null,

  loading: {
    submit: false,
  },
  errors: {
    submit: "",
    fields: {},
  },
};
